import React from 'react'
import {
  TableItemBody,
  TableItemContainer,
} from 'components/Table/Table.styled'
import { RelationshipItemText } from './Relationships.styled'
import { useAppState } from 'store'
import Button from 'components/Button/Button'
import { useHistory } from 'react-router'

const RelationshipsItem: React.FC = () => {
  const { push } = useHistory()
  const { userProfile } = useAppState(state => state.user)
  const parent = userProfile && userProfile.parent
  const siblings = userProfile && userProfile.siblings
  const children = userProfile && userProfile.children

  const navigateToRelationProfile = (userId: number) => {
    if (userId) {
      push('/locations/8/settings/clients/' + userId)
    }
  }
  return (
    <>
      {parent && parent.title && (
        <TableItemContainer>
          <TableItemBody>
            <RelationshipItemText>{parent.title}</RelationshipItemText>
          </TableItemBody>
          <TableItemBody>
            <RelationshipItemText></RelationshipItemText>
          </TableItemBody>
          <TableItemBody>
            <RelationshipItemText>
              <Button
                text=" View Profile"
                variant="primary"
                preset="filled"
                size={'small'}
                onClick={() => navigateToRelationProfile(parent.id)}
              />
            </RelationshipItemText>
          </TableItemBody>
          <TableItemBody>
            <RelationshipItemText>Parent</RelationshipItemText>
          </TableItemBody>
        </TableItemContainer>
      )}
      {siblings &&
        siblings.length > 0 &&
        siblings.map(sibling => (
          <TableItemContainer key={sibling.id}>
            <TableItemBody>
              <RelationshipItemText>{sibling.title}</RelationshipItemText>
            </TableItemBody>
            <TableItemBody>
              <RelationshipItemText></RelationshipItemText>
            </TableItemBody>
            <TableItemBody>
              <Button
                text=" View Profile"
                variant="primary"
                preset="filled"
                size={'small'}
                onClick={() => navigateToRelationProfile(sibling.id)}
              />
            </TableItemBody>
            <TableItemBody>
              <RelationshipItemText>Siblings</RelationshipItemText>
            </TableItemBody>
          </TableItemContainer>
        ))}
      {children &&
        children.length > 0 &&
        children.map(child => (
          <TableItemContainer key={child.id}>
            <TableItemBody>
              <RelationshipItemText>{child.title}</RelationshipItemText>
            </TableItemBody>
            <TableItemBody>
              <RelationshipItemText></RelationshipItemText>
            </TableItemBody>
            <TableItemBody>
              <RelationshipItemText>
                <Button
                  text=" View Profile"
                  variant="primary"
                  preset="filled"
                  size={'small'}
                  onClick={() => navigateToRelationProfile(child.id)}
                />
              </RelationshipItemText>
            </TableItemBody>
            <TableItemBody>
              <RelationshipItemText>Children</RelationshipItemText>
            </TableItemBody>
          </TableItemContainer>
        ))}
    </>
  )
}

export default RelationshipsItem
